// extracted by mini-css-extract-plugin
export default {"ref":"ref_ref__cFD1f","link":"ref_link__9T6iZ"};